import PropTypes from 'prop-types';
import React from 'react';
import PersonalInformationDisplay from './Names/PersonalInformationDisplay';
import DateOfBirthDisplay from './DateOfBirth/DateOfBirthDisplay';
import CitizenshipDisplay from './Citizenship/CitizenshipDisplay';
import SSNDisplay from './SSN/SSNDisplay';
import IdentifiesAsDisplay from './IdentifyAs/IdentifiesAsDisplay';
import SexualOrientationDisplay from './SexualOrientation/SexualOrientationDisplay';
import PopulationsAndConditionsDisplay from './PopulationsAndConditions/PopulationsAndConditionsDisplay';
var PersonalData = function PersonalData(_ref) {
  var contact = _ref.contact,
    lastUpdate = _ref.lastUpdate,
    shouldShowLastUpdate = _ref.shouldShowLastUpdate,
    shouldShowSexualityFields = _ref.shouldShowSexualityFields,
    limitedGenderOptions = _ref.limitedGenderOptions,
    shouldShowPopulationsAndConditions = _ref.shouldShowPopulationsAndConditions;
  return /*#__PURE__*/React.createElement("div", {
    className: "row personal-data mb-one"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("h3", null, "Personal Information"), /*#__PURE__*/React.createElement(PersonalInformationDisplay, {
    contact: contact,
    lastUpdate: lastUpdate,
    shouldShowLastUpdate: shouldShowLastUpdate
  }), /*#__PURE__*/React.createElement(DateOfBirthDisplay, {
    contact: contact
  }), shouldShowPopulationsAndConditions && /*#__PURE__*/React.createElement(PopulationsAndConditionsDisplay, {
    contact: contact
  }), /*#__PURE__*/React.createElement(CitizenshipDisplay, {
    contact: contact
  }), /*#__PURE__*/React.createElement(SSNDisplay, {
    contact: contact
  }), /*#__PURE__*/React.createElement(IdentifiesAsDisplay, {
    contact: contact,
    limitedGenderOptions: limitedGenderOptions
  }), shouldShowSexualityFields && /*#__PURE__*/React.createElement(SexualOrientationDisplay, {
    contact: contact
  })));
};
PersonalData.propTypes = {
  contact: PropTypes.object.isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool,
  limitedGenderOptions: PropTypes.bool.isRequired,
  shouldShowPopulationsAndConditions: PropTypes.bool.isRequired
};
PersonalData.defaultProps = {
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null
  },
  shouldShowLastUpdate: false
};
export default PersonalData;
//# sourceMappingURL=index.js.map